/**
 * PD-7032: On restaurant page reviews, show Gold and Platinum Frequent Foodies tiers as a tag beside the reviewer's name. Other reviewers stay on control.
 *
 * @see https://firsttable.atlassian.net/browse/PD-7032
 * @see https://app.growthbook.io/features/pd-7032-highlight-top-bookers-in-the-restaurant-page-reviews
 */
export const PD7032_HIGHLIGHT_TOP_BOOKERS_FLAG =
  'pd-7032-highlight-top-bookers-in-the-restaurant-page-reviews';
